import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider } from "@/lib/site";
import PublicLayout from "@/components/site/PublicLayout";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import PropertyDetail from "@/pages/PropertyDetail";
import ZonePage from "@/pages/ZonePage";
import { Services, PublishProperty, Legal } from "@/pages/PublicPages";
import { AuthProvider } from "@/admin/AuthContext";
import Login from "@/admin/Login";
import AdminLayout from "@/admin/AdminLayout";
import Dashboard from "@/admin/Dashboard";
import { PropertiesAdmin, CrmAdmin, OwnersAdmin, AgentsAdmin, DealsAdmin } from "@/admin/CrmPages";
import { FinanceAdmin, ConstructionAdmin, ConstructionDetail } from "@/admin/FinancePages";
import IgAds from "@/admin/IgAds";
import Sales from "@/admin/Sales";
import HeavyPage, { JobReport } from "@/admin/heavy/HeavyPage";
import { JobDetail } from "@/admin/heavy/Jobs";
import { ZonesAdmin, SettingsAdmin, UsersAdmin, AuditAdmin } from "@/admin/ContentPages";
import VideoStudio from "@/admin/VideoStudio";
import VideoEditor from "@/admin/VideoEditor";

function App() {
  return (
    <BrowserRouter>
      <SiteProvider>
        <AuthProvider>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/propiedades" element={<Catalog />} />
              <Route path="/propiedad/:code" element={<PropertyDetail />} />
              <Route path="/zonas/:slug" element={<ZonePage />} />
              <Route path="/servicios" element={<Services />} />
              <Route path="/publica-tu-propiedad" element={<PublishProperty />} />
              <Route path="/legal" element={<Legal />} />
            </Route>
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="propiedades" element={<PropertiesAdmin />} />
              <Route path="crm" element={<CrmAdmin />} />
              <Route path="propietarios" element={<OwnersAdmin />} />
              <Route path="agentes" element={<AgentsAdmin />} />
              <Route path="negociaciones" element={<DealsAdmin />} />
              <Route path="contabilidad" element={<FinanceAdmin />} />
              <Route path="publicidad" element={<IgAds />} />
              <Route path="ventas" element={<Sales />} />
              <Route path="equipos" element={<HeavyPage />} />
              <Route path="equipos/trabajos/:id" element={<JobDetail />} />
              <Route path="equipos/trabajos/:id/reporte" element={<JobReport />} />
              <Route path="construccion" element={<ConstructionAdmin />} />
              <Route path="construccion/:id" element={<ConstructionDetail />} />
              <Route path="video" element={<VideoStudio />} />
              <Route path="video/:id" element={<VideoEditor />} />
              <Route path="zonas" element={<ZonesAdmin />} />
              <Route path="contenido" element={<SettingsAdmin />} />
              <Route path="usuarios" element={<UsersAdmin />} />
              <Route path="auditoria" element={<AuditAdmin />} />
            </Route>
          </Routes>
          <Toaster richColors position="bottom-right" />
        </AuthProvider>
      </SiteProvider>
    </BrowserRouter>
  );
}

export default App;
